var layout_default = {
  "layout": "_0aBvJ",
  "cell": "ERcZc"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
